import { useRemoteResource } from "./useRemoteResource";
import { useScoreApi, unwrap } from "../api/scoreApi";

// #2141 (docs/score/announcer-ui-redesign.md §5) -- the whole-show list's
// ONE data call: every Ride for the show, across every ring and every day,
// no `ring`/`day` narrowing (AC8: "uses GET /ride with showId only -- no
// new API route and no per-class fan-out"). Deliberately its OWN hook, not
// a field added to RingDataContext: RingDataProvider mounts OUTSIDE the
// nested <Routes> (App.jsx ~line 276), so it is already live for every route
// inside those Routes, /list included -- this hook is not exempt from that.
// What it IS exempt from is the shared context's OWN poll set: because
// useRidesForShow is called only from WholeShowList itself (never added to
// RingDataContext), its one GET /ride?showId= call fires only while /list is
// actually mounted, and never shows up in ring-data-poll-set.cy.js's pinned
// per-hook counts (queue gotcha #2) -- those are measured with the four
// bands mounted and /list NOT mounted, so a call this hook makes there would
// never appear in that spec regardless. Adding this fetch to RingDataContext
// instead would make every band consumer pay for it even while /list is
// closed, which is the thing actually worth avoiding here.
//
// Same generated-client positional-arg shape as useRidesForRing
// (listRides(classId, showId, day, ring, ...)) -- a show-wide query is
// listRides(undefined, showId).
export function useRidesForShow(showId, nonce = 0) {
  const api = useScoreApi();
  return useRemoteResource(
    async () => {
      if (!showId) return [];
      return unwrap(await api.rides.listRides(undefined, showId)) ?? [];
    },
    [api, showId, nonce],
    [showId],
  );
}

export default useRidesForShow;
